import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { WebhookEventsPage } from 'features/webhooks'
import { canViewConfigurationPermission } from 'hooks/usePermission'
import { WebhookEventStatus } from 'models'
import { z } from 'zod/v4'

const eventsFilterSearchSchema = z.object({
  requestId: z.coerce.string().optional(),
  visitorId: z.coerce.string().optional(),
  limit: z.coerce.number().optional(),
  status: z.enum([WebhookEventStatus.All, WebhookEventStatus.Succeeded, WebhookEventStatus.Failed]).optional(),
})

export type EventsFilterSearch = z.infer<typeof eventsFilterSearchSchema>

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/webhooks/$webhookId/events')({
  component: WebhookEventsPage,
  validateSearch: eventsFilterSearchSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Webhook Events'),
      },
    ],
  }),
  beforeLoad: (ctx) => protectWithWorkspacePermissions(canViewConfigurationPermission)(ctx),
})
